import { css } from "@emotion/react";
import { Colors } from "theme/colors";

export const baseStyles = css`
  // color
  color: ${Colors.TEXT_GRAY};
  &:disabled {
    color: ${Colors.DARK_GRAY};
  }

  // padding
  padding: 0.625rem 1rem 0.45rem 1rem;

  // border
  border: 0.059rem solid ${Colors.MID_GRAY};

  // background
  background-color: ${Colors.WHITE};
  &:disabled {
    background-color: ${Colors.LIGHT_GRAY};
  }
`;
